import { useGalleryItemQuery } from '../core/queries/galleryItem';
import i18n from '../locales/i18n';

export default function useGalleryItem(id) {
  const query = useGalleryItemQuery(id);
  const item = query.data?.item || null;

  let error = null;
  if (query.isError) {
    const status = query.error?.response?.status;
    if (status === 404) {
      error = i18n.t('gallery.recordNotFound', 'Record not found');
    } else if (status === 401) {
      error = i18n.t('gallery.authRequired', 'Authorization required');
    } else {
      error = i18n.t('viewer.somethingWrong');
    }
  } else if (query.isSuccess && !item) {
    error = i18n.t('gallery.recordNotFound', 'Record not found');
  }

  return {
    item,
    loading: query.isLoading,
    error,
    refetch: query.refetch,
  };
}
